import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { SMS_REDIRECT_TO_LOGIN } from '../../../actions/actionTypes'
import { stripQueryString, takeQueryParams } from '../../../libs/historyHelper'
import { REDIRECT_ACCOUNT_KEY } from '../forgetPasswordHelper'

export default function useRedirectFromResetPassword(): () => boolean {
  const dispatch = useDispatch()
  return useCallback(() => {
    const queryParams = takeQueryParams([REDIRECT_ACCOUNT_KEY])
    const account = queryParams[REDIRECT_ACCOUNT_KEY]
    if (typeof account === 'string' && account.length > 0) {
      dispatch({ type: SMS_REDIRECT_TO_LOGIN, payload: account })
      stripQueryString([REDIRECT_ACCOUNT_KEY])
      return true
    }
    return false
  }, [dispatch])
}
